import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
export var MediaObject = React.forwardRef(function MediaObject(_a, ref) {
    var _b;
    var _c = _a.align, align = _c === void 0 ? "top" : _c, reverse = _a.reverse, media = _a.media, children = _a.children, className = _a.className, props = __rest(_a, ["align", "reverse", "media", "children", "className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", __assign({ ref: ref, className: classNames(className, classPrefix + "-media", (_b = {},
            _b[classPrefix + "-media--reverse"] = reverse,
            _b[classPrefix + "-media--middle"] = align === "middle",
            _b[classPrefix + "-media--bottom"] = align === "bottom",
            _b)) }, props),
        media && React.createElement("div", { className: classPrefix + "-media__left" }, media),
        React.createElement("div", { className: classPrefix + "-media__body" }, children)));
});
MediaObject.displayName = "MediaObject";
//# sourceMappingURL=MediaObject.js.map